import {FC, useEffect} from 'react';
import UpdateTemplateForm from '../../Forms/Lottery/UpdateLotteryTemplate/UpdateLotteryTemplate';
import {useParams,useNavigate} from 'react-router-dom';
import Button from '../../../components/UI/Button/Button';
import ViewHeader from '../../../components/ViewHeader/ViewHeader';
import {getUpdateTemplateDetail, setUpdateTemplate, updateLotteryTemplate} from '../../../features/updateTemplateSlice';
import {updateLottery} from '../../../features/lotteryListSlice';
import {useSelector, useDispatch} from 'react-redux';
import { RootState } from '../../../app/Store';
import {setUpdateImgDetails} from '../../../features/imageUploaderSlice';
import {adminRouts} from '../../../routs';

import {Breadcrumbs, DeleteBtn} from './StyledUpdateTemplate';

import {validateCreateRepeatLottery} from '../../../Utility/formValidation';
import {NotificationType} from '../../../Utility/InterFacesAndEnum';
import {toggleNotificationVisibility} from '../../../features/networkNotification';

import {removeTemplate,setTemplateRemoveStatus} from '../../../features/templateListslice';

enum ButtonSize {
    sm = "small",
    md = "medium",
    lg = "large"
}
enum ButtonVariant {
    primaryFilled = "primary-filled",
    secondary = "secondary",
    primaryLink = "primaryLink"
}

const UpdateTemplate:FC = () => {

    const templateObj = useSelector((state: RootState) => state.updateTemplate.templateObj);
    const isTemplateDelete = useSelector((state: RootState) => state.templateList.isTemplateDeleted);
    const updateStatus = useSelector((state:RootState)=>state.updateTemplate.updateStatus);


    const params = useParams();
    const dispatch = useDispatch();
    const navigation = useNavigate()

    useEffect(() => {
        let {lotteryId} = params;
        dispatch(getUpdateTemplateDetail(lotteryId ? lotteryId : ""));
        return () => {
            dispatch(setUpdateTemplate({
                templateObj:{
                    lotteryId:""
                }
            }))
        }
    },[]);

    const navigateToView = (path:string):void => {
        navigation(path);
    };

    useEffect(()=>{
        if(updateStatus===true){
            navigateToView(`${adminRouts.gamesList}`);
        }
    },[updateStatus])

    useEffect(() => {
        if (isTemplateDelete === true) {
            dispatch(setTemplateRemoveStatus({status:false}));
            navigateToView(`${adminRouts.gamesList}`);
        }
    },[isTemplateDelete]);

    const updateLotteryDetails = (updateObj:any) => {
        let validatedObj = validateCreateRepeatLottery(updateObj);
        if (validatedObj.status) {
            // dispatch(updateLottery(updateObj));
            dispatch(updateLotteryTemplate(updateObj));
            console.log(updateObj)
        } else {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: validatedObj.message
            }));
        }
    };

    const deleteTemplate = (obj:any) => {
        // console.log(obj)
        dispatch(removeTemplate({templateId:obj.lotteryId}));
    }

    let view  = Object.keys(templateObj).length > 0 ? 
    <>
     <Breadcrumbs>
    <ViewHeader title={`Update lottery`} isBackButtonRequired={true} backButtonRedirectionUrl={adminRouts.gamesList} />
    {/* <Button title={"Delete"} btnSize={ButtonSize.md} btnVariant={ButtonVariant.secondary} 
     clicked={() => {deleteTemplate(templateObj)}} /> */}
     <DeleteBtn onClick={() => {deleteTemplate(templateObj)}}>
    Delete
    </DeleteBtn>
    </Breadcrumbs>
    <UpdateTemplateForm onCreateLottery={updateLotteryDetails} onCancel={() => {navigateToView(adminRouts.gamesList)}} templateDetail={templateObj} /> 
    </> : 
    <div>Please wait</div>

    return view
};

export default UpdateTemplate